'use client'

import { Button, Text } from '@vinted/web-ui'
import classNames from 'classnames'

import { BrandModel } from '@marketplace-web/personalization/brands-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useFollowBrand } from '@marketplace-web/personalization/follow-brand-feature'

type Props = {
  brand: BrandModel
}

const BrandBox = ({ brand }: Props) => {
  const translate = useTranslate('personalization.brands.brand_box')

  const { isFollowed, toggleFollow } = useFollowBrand({
    brandId: brand.id,
    isFollowed: brand.isFavourite,
  })

  function handleToggleFavouriteClick() {
    toggleFollow()
  }

  function renderTitle() {
    return (
      <a className="follow__name" href={brand.path} data-testid="brand-name">
        <Text as="h3" truncate type="title">
          {brand.title}
        </Text>
      </a>
    )
  }

  function renderDetails() {
    return (
      <div className="follow__details" data-testid="brand-details">
        <Text as="p">
          {translate('items', { count: brand.itemCount }, { count: brand.itemCount })}
        </Text>
      </div>
    )
  }

  return (
    <article className={classNames('follow', { 'is-active': isFollowed })}>
      <div className="u-overflow-hidden u-padding-right-small">
        {renderTitle()}
        {renderDetails()}
      </div>
      <Button
        styling="outlined"
        size="small"
        onClick={handleToggleFavouriteClick}
        inline
        testId={isFollowed ? 'brand-unfollow-button' : 'brand-follow-button'}
      >
        {translate(`actions.${isFollowed ? 'remove_from_favourites' : 'add_to_favourites'}`)}
      </Button>
    </article>
  )
}

export default BrandBox
